import { Typography } from "@mui/material";
import useCategories from "../utils/useCategories";
import useCart from "../utils/useCart";
import Loader from "../../Tools/Loader";

export default function Categories(){

    const categories = useCategories()

    const { cart, setCart } = useCart();

    const handleClick = category => {
        
        setCart({ 
            category: category.id, 
            status: null, 
            product: null, 
            session: null 
        })
    }

    return <>

        <Typography variant="h5" align="center">Votre filière de santé :</Typography>

        {categories.isLoading &&
        
            <Loader />
        }

        {categories.isSuccess && 

            <div className="apply-choices">

                {categories.data.map(cat => 
                    <div
                        key={cat.id}
                        className="apply-choice" 
                        onClick={() => handleClick(cat)}
                        style={cat.id === cart.category ? {
                            backgroundColor: cat.color,
                            borderColor: cat.color,
                            color: 'white'
                        } : null}
                    >
                        <span>{cat.title}</span>
                    </div>    
                )}

            </div>
        }

    </>
}